<template>
  <li
    class="sidebar-item__wrapper"
    :class="{ active: isPathActive(item.link) }"
    data-testid="sidebar-item"
  >
    <RouterLink
      :to="item.link"
      class="sidebar-item"
    >
      <div
        v-if="item.icon"
        class="icon-prefix"
      >
        <component
          :is="item.icon"
          bigger
        />
        <span class="sidebar-item__badge">
          <BadgeNumeric :value="item.badge" />
        </span>
      </div>
      <label class="sidebar-item__title">
        {{ item.label }}
      </label>
    </RouterLink>
  </li>
</template>

<script>
import { useRoute } from 'vue-router'
import BadgeNumeric from '@/components/common/BadgeNumeric.vue'

export default {
  name: 'TalentSideBarItem',
  components: { BadgeNumeric },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      route: useRoute()
    }
  },
  methods: {
    stripLocalePrefix(path) {
      return path.replace(/^\/(en|de)(?=\/)/, '')
    },

    isPathActive(targetPath) {
      const current = this.stripLocalePrefix(this.route.path)
      const target = this.stripLocalePrefix(targetPath)

      return current === target || current.startsWith(target + '/')
    }
  }
}
</script>

<style scoped lang="scss">
$badge-gap: var(--space-8);

.sidebar-item__wrapper {
  @include phone {
    flex: 1 0 auto;
  }

  &.active .sidebar-item {
    background: rgba(255, 255, 255, 0.85);
    border-radius: var(--border-radius-12);
    color: var(--color-brand-500);

    svg {
      color: var(--color-brand-500);
    }
  }
}

.sidebar-item {
  display: block;
  color: #ffffff; // should be always white
  cursor: pointer;
  padding: var(--space-24) 0;
  text-decoration: none;
  margin: 0 var(--space-4);

  .icon-prefix {
    color: #ffffff; // should be always white
    display: block;
    width: max-content;
    margin: auto;
    position: relative;

    svg {
      width: var(--space-48);
      height: var(--space-48);
    }

    .sidebar-item__badge {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;

      :deep(.badge-numeric) {
        color: #ffffff; // should be always white
      }
    }
  }

  @include phone {
    padding-top: var(--space-12);
    padding-bottom: var(--space-16);
    transition: 0.1s ease-in-out;

    .sidebar-item__title {
      display: none;
    }

    .icon-prefix {
      svg {
        width: var(--space-24);
        height: var(--space-24);
      }

      .sidebar-item__badge {
        top: -5px;
        right: -10px;
      }
    }

    .active & {
      background: unset;
      padding-top: var(--space-4);
      padding-bottom: var(--space-12);
      color: var(--color-white);

      svg {
        color: var(--color-white);
      }

      &::after {
        content: '';
        display: block;
        width: var(--interface-size-middle);
        height: var(--interface-size-middle);
        border-radius: var(--border-radius-rounded);
        background-color: var(--color-white);
        margin: var(--space-4) auto 0;
      }
    }
  }
}
</style>
